"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrAutocompleteOptionLoader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const AutocompleteOptionLoaderWrapper = styled_components_1.default.div(({ theme: { colors } }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'inline-block',
    animation: 'rotate 1s linear infinite',
    background: colors.secondary,
    borderRadius: '50%',
    height: '24px',
    width: '24px',
    position: 'relative',
    '.left': {
        position: 'absolute',
        borderRadius: '50%',
        background: 'linear-gradient(0deg,   hsla(0, 0%, 100%, 1  ) 50%, hsla(0, 0%, 100%, 0.9) 100%)   0%   0%,' +
            'linear-gradient(90deg,  hsla(0, 0%, 100%, 0.9)  0%, hsla(0, 0%, 100%, 0.6) 100%) 100%   0%,' +
            'linear-gradient(180deg, hsla(0, 0%, 100%, 0.6)  0%, hsla(0, 0%, 100%, 0.3) 100%) 100% 100%,' +
            'linear-gradient(360deg, hsla(0, 0%, 100%, 0.3)  0%, hsla(0, 0%, 100%, 0  ) 100%)   0% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '50% 50%',
        top: '-1px',
        bottom: '-1px',
        left: '-1px',
        right: '-1px',
    },
    '.right': {
        position: 'absolute',
        background: '#fff',
        borderRadius: '50%',
        top: '10%',
        bottom: '10%',
        left: '10%',
        right: '10%',
    },
    '.tip': {
        position: 'absolute',
        display: 'block',
        borderRadius: '50%',
        background: colors.secondary,
        width: '2px',
        height: '2px',
        left: 0,
        zIndex: 1,
        top: '45%',
    },
}));
function FdrAutocompleteOptionLoader() {
    return (react_1.default.createElement(AutocompleteOptionLoaderWrapper, null,
        react_1.default.createElement("div", { className: "left" }),
        react_1.default.createElement("div", { className: "right" }),
        react_1.default.createElement("div", { className: "tip" })));
}
exports.FdrAutocompleteOptionLoader = FdrAutocompleteOptionLoader;
//# sourceMappingURL=fdr-autocomplete-option-loader.js.map